export default __webpack_public_path__ + "static/legal-c67ef1b5a767e2670c545c2d36c931d8.svg";